import { render, staticRenderFns } from "./ProposalImage.vue?vue&type=template&id=d7afc420&"
import script from "./ProposalImage.vue?vue&type=script&lang=js&"
export * from "./ProposalImage.vue?vue&type=script&lang=js&"
import style0 from "./ProposalImage.vue?vue&type=style&index=0&id=d7afc420&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
